import '../../../base_builders/vertical/rcp/rcp_base_builder';

import Comments from "../../../../assets/js/Widgets/SpotIM/Comments";
Comments();

import RcmgSpot from '../../../../assets/js/RCMG_V2/RcmgSpot.js';